import { RouterProvider } from 'react-router-dom';

import { Providers } from './providers';
import { RootGate } from './RootGate';
import { router } from './router';

export default function App() {
  return (
    <Providers>
      <RootGate>
        <RouterProvider router={router} />
      </RootGate>
    </Providers>
  );
}
